import { CopyToClipboard } from "react-copy-to-clipboard";
import { LuCopy, LuSquarePen } from "react-icons/lu";
import { useAuthUser } from "../../../core_stores/useAuthStore";
import { useSnackbar } from "../../../providers/SnackbarProvider";

export default function PersonalSettingsYourProfile() {
  return (
    <div>
      <div className="flex flex-col gap-4">
        <PersonalInfo />
        <hr className="border-[#8B8B8B4D] my-2" />
        <UserId />
      </div>
    </div>
  );
}

function PersonalInfo() {
  const user = useAuthUser();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-4">
        <div
          className="w-[50px] h-[50px] 
                      rounded-full bg-primary-blue
            flex items-center justify-center
            text-white text-[40px] overflow-hidden"
        >
          <img src={user?.photoURL || ""} />
        </div>
        <div className="text-md">
          <div className="text-light-text dark:text-dark-text">
            {user?.displayName}
          </div>
          <div className="text-light-placeholder dark:text-[#8B8B8B]">
            {user?.email}
          </div>
        </div>
      </div>
      <button
        className="flex items-center gap-[8px] border 
            text-light-text dark:text-[#8B8B8B]
          border-[#303535] dark:border-[#8B8B8B] 
          rounded-[6px] h-10 px-[14px]
          hover:bg-light-hover dark:hover:bg-gray-700
          transition-colors duration-300"
      >
        <LuSquarePen size={14} />
        Edit
      </button>
    </div>
  );
}

function UserId() {
  const user = useAuthUser();
  const { showSnackbar } = useSnackbar();

  const handleCopy = () => {
    if (!user?.uid) {
      showSnackbar("User ID is not available", {
        type: "error",
      });
      return;
    }
    showSnackbar("User ID copied to clipboard");
  };

  return (
    <div className="flex items-center justify-between gap-4">
      <div className="text-md">
        <div className="text-light-text dark:text-dark-text">ID</div>
        <div className="text-light-placeholder dark:text-[#8B8B8B]">
          {user?.uid}
        </div>
      </div>
      <CopyToClipboard text={user?.uid || ""} onCopy={handleCopy}>
        <button
          className="flex items-center justify-center 
              text-light-text dark:text-[#8B8B8B]
            border-[#303535] dark:border-[#8B8B8B] 
            border rounded-[6px] h-10 w-10
            hover:bg-light-hover dark:hover:bg-gray-700
            transition-colors duration-300"
          title="Copy ID"
        >
          <LuCopy size={20} />
        </button>
      </CopyToClipboard>
    </div>
  );
}
